export default __webpack_public_path__ + "static/media/Beard_4_C1.652f92d5.svg";